import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import {
  Button,
  Col,
  Container,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import "../../assets/styles/addresses.scss";

const NewAddressButtons = ({ onSearch }) => {
  const navigate = useNavigate();

  const renderSearchTooltip = (props) => (
    <Tooltip id="search-tooltip" {...props}>
      Szukaj
    </Tooltip>
  );

  const renderAddTooltip = (props) => (
    <Tooltip id="add-tooltip" {...props}>
      Dodaj nowy adres
    </Tooltip>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderSearchTooltip}
          >
            <Button className="addresses-button" onClick={onSearch}>
              <img
                src={searchIcon}
                alt="Search"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderAddTooltip}
          >
            <Button
              className="addresses-button"
              variant="outline-success"
              onClick={() => navigate("/administration/new-addresses/add")}
            >
              +
            </Button>
          </OverlayTrigger>
        </Col>
      </Row>
    </Container>
  );
};

export default NewAddressButtons;
